import type { MaterialDefinition } from '@h5/schema';

const registry = new Map<string, MaterialDefinition>();

export function registerMaterial(def: MaterialDefinition<any>): void {
  if (registry.has(def.id)) throw new Error(`物料 ${def.id} 重复注册`);
  registry.set(def.id, def as MaterialDefinition);
}

export function getMaterial(type: string): MaterialDefinition | undefined {
  return registry.get(type);
}

export function requireMaterial(type: string): MaterialDefinition {
  const def = registry.get(type);
  if (!def) throw new Error(`未知物料: ${type}`);
  return def;
}

export function listMaterials(): MaterialDefinition[] {
  return [...registry.values()];
}
